"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var makeLazyComponent = function (load, fallback) {
    var LazyComponent = react_1.lazy(load);
    return function (props) {
        return react_1.createElement(react_1.Suspense, { fallback: fallback }, react_1.createElement(LazyComponent, props));
    };
};
exports.default = makeLazyComponent;
//# sourceMappingURL=makeLazyComponent.js.map